import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'dva';
import { Toast } from 'antd-mobile';
import { Swiper } from 'antd-mobile-v5';
import { Button } from '@digitalc/dxp-ui';
import useGCPI18n from '@/hooks/useGCPI18n';
import { appUrlJump, goBack } from '@/utils/utils';
import Header from '@/components/Header';
import BaseSpin from '@/components/BaseSpin';
import hiappLoading from '@/assets/images/hiapp_loading.gif';
import styles from './index.less';

const getInitialLevelIndex = (levels, levelCode) => {
  const idx = levels.findIndex(item => item.levelCode === levelCode);
  return idx >= 0 ? idx : 0;
};
const MemberShipLevelGuide = props => {
  const { dispatch, loading } = props;
  const GCPI18n = useGCPI18n();
  const swiperRef = useRef(null);
  const [levelList, setLevelList] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [membershipTypeCode, setMembershipTypeCode] = useState(null);

  const jumpByGuide = guide => {
    const url = guide?.url;
    if (url) {
      appUrlJump(url, true);
    }
  };

  const handleTopUp = () => {
    dispatch({ type: 'memberShipCenter/qryUpgradeGuidUrl', payload: { membershipTypeCode } }).then(
      res => {
        if (res?.resultCode === '0') {
          jumpByGuide(res?.data);
          return;
        }
        Toast.fail(res?.resultMsg);
      },
    );
  };

  const handleSelectLevel = index => {
    setActiveIndex(index);
    swiperRef.current?.swipeTo(index);
  };

  // 键盘可达：轮播圆点与等级项需支持 Enter/Space 触发选择
  const handleSelectLevelKeyDown = (index, e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    handleSelectLevel(index);
  };

  useEffect(() => {
    dispatch({ type: 'memberShipCenter/qryUserMMSInfoDXP', payload: {} }).then(memberRes => {
      if (memberRes?.retCode !== '0') {
        Toast.fail(memberRes?.retDesc);
        return;
      }

      const currentMemberInfo = memberRes.data;
      if (currentMemberInfo?.membershipTypeCode) {
        setMembershipTypeCode(currentMemberInfo?.membershipTypeCode);
        dispatch({
          type: 'memberShipCenter/qryMMSTypeInfoDXP',
          payload: currentMemberInfo?.membershipTypeCode,
        }).then(typeRes => {
          if (typeRes?.retCode !== '0') {
            Toast.fail(typeRes?.retDes);
            return;
          }

          const levels = (typeRes?.data?.membershipLevelList || []).sort(
            (a, b) => (a.seq ?? 0) - (b.seq ?? 0),
          );
          const selectedIndex = getInitialLevelIndex(levels, currentMemberInfo?.levelCode);
          setLevelList(levels);
          setActiveIndex(selectedIndex);
          requestAnimationFrame(() => swiperRef.current?.swipeTo(selectedIndex));
        });
      }
    });
  }, []);

  return (
    <div className={styles.page}>
      <Header
        title={GCPI18n({ id: 'lb_membership_level_guide_title' })}
        hideClose
        isArrowLeft
        isHiddenBorder
        goBack={goBack}
      />
      <BaseSpin spinning={loading} loadingImg={hiappLoading}>
        <div className={styles.content}>
          <div className={styles.cardWrap}>
            <Swiper
              ref={swiperRef}
              slideSize={100}
              trackOffset={0}
              stuckAtBoundary={false}
              indicator={false}
              defaultIndex={activeIndex}
              onIndexChange={setActiveIndex}
            >
              {levelList.map((item, index) => (
                <Swiper.Item key={item.levelCode || index}>
                  <div
                    className={styles.levelCard}
                    style={
                      item.backgroundImageUrl
                        ? { backgroundImage: `url(${item.backgroundImageUrl})` }
                        : {}
                    }
                  >
                    <div className={styles.levelName}>{item.levelName || '-'}</div>
                  </div>
                </Swiper.Item>
              ))}
            </Swiper>
          </div>
          <div className={styles.perksTitle}>
            {GCPI18n({ id: 'lb_membership_enjoy_perks_all_year_round' })}
          </div>

          <div className={styles.detailList}>
            {levelList.map((item, index) => (
              <div
                key={item.levelCode || index}
                role="button"
                tabIndex={0}
                className={`${styles.detailItem} ${
                  index === activeIndex ? styles.detailItemActive : ''
                }`}
                onClick={() => handleSelectLevel(index)}
                onKeyDown={e => handleSelectLevelKeyDown(index, e)}
              >
                <div className={styles.detailHeader}>
                  <div className={styles.levelLogo}>
                    {item?.imageUrl && <img src={item?.imageUrl} alt="" />}
                  </div>
                  <div className={styles.detailTitle}>{item?.levelName || '-'}</div>
                </div>
                {item?.comments && <div className={styles.detailDesc}>{item?.comments}</div>}
              </div>
            ))}
          </div>
        </div>

        <div className={styles.bottomBar}>
          <Button
            block
            type="primary"
            style={{ width: '100%' }}
            // style={{ color: dxpToken.colorTextNeutral }}
            onClick={handleTopUp}
          >
            {GCPI18n({ id: 'btn_membership_top_up_wallet' })}
          </Button>
        </div>
      </BaseSpin>
    </div>
  );
};

export default connect(({ loading }) => ({
  loading: loading.effects['memberShipCenter/qryMMSTypeInfoDXP'] || false,
}))(MemberShipLevelGuide);
